module.exports = __webpack_public_path__ + "static/AIinStateandLocal2xheader-cf91ad4a8cc58a850cde2f036a6f383a.png";